import { KEYCODE } from '../../constants';

class MelNav extends HTMLElement {
  constructor(self) {
    self = super(self);
    this._header = document.querySelector('mel-header');
    this._toggle = document.querySelectorAll('[data-menu-toggle]');
    return self;
  }

  static get is() {
    return 'mel-nav';
  }

  /**
   * Watched attributes
   *
   * @readonly
   * @static
   */
  static get observedAttributes() {
    return ['opened'];
  }

  /**
   * Getter for `opened` attribute
   */
  get opened() {
    return this.hasAttribute('opened');
  }

  /**
   * Setter for `opened` attribute
   */
  set opened(value) {
    if (Boolean(value)) {
      this.setAttribute('opened', '');
    } else {
      this.removeAttribute('opened');
    }
  }

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'navigation');
    }

    this._bindHandlers();
    this._addEventListeners();
  }

  disconnectedCallback() {
    window.removeEventListener('keydown', this._handleKeyDown, false);
  }

  _bindHandlers() {
    this._handleKeyDown = this._handleKeyDown.bind(this);
  }

  _addEventListeners() {
    window.addEventListener('keydown', this._handleKeyDown, false);

    if (this._header) {
      this._header.addEventListener('menutoggle', () => {
        this.opened = this.opened ? false : true;
      });
    }
  }

  /**
   * Lifecycle event when watched attribute is changed
   *
   * @param {string} name Attribute name
   * @param {any} oldVal Old value of attribute
   * @param {any} newVal New value of attribute
   */
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'opened':
        this._openedChanged();
    }
  }

  /**
   * Called when `opened` attribute changed
   *
   * @private
   */
  _openedChanged() {
    if (this.opened) {
      // If opened, scroll to top
      this.scrollTop = 0;
      document.body.classList.add('nav-is-open');
    } else {
      document.body.classList.remove('nav-is-open');
    }
    this._toggle.forEach(toggle => toggle.setAttribute('aria-expanded', this.opened))
  }

  /**
   * Event handler for `keydown` event
   *
   * @private
   * @param {UIEvent} evt
   */
  _handleKeyDown(evt) {
    const keyCode = evt.which;

    // If menu open on ESC, close
    if (keyCode === KEYCODE.ESC) {
      this.opened = false;
    }
  }
}

customElements.define(MelNav.is, MelNav);
